import { EK_STORAGE_BASE_URL } from 'utils/url'

export const storageUrl = EK_STORAGE_BASE_URL
